import {Component, Input, OnInit} from '@angular/core';
import {ConnecttocrudService} from "../connecttocrud.service";
import {ActivatedRoute, Router} from "@angular/router";
import {LeftpanelComponent} from "../leftpanel/leftpanel.component";
import {MatDialog} from "@angular/material";
import {ConfService} from "../conf.service";

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss']
})
export class DocumentationComponent implements OnInit {

  _terms: any;
  display = [];
  full: any;
  title: any;
  version: any;
  selected: any;
  edit = false;
  schema = {
    'title': '',
    'description': '',
    'sub_sections': []
  };
  apisByCategory: any;
  businessLogic = [];
  isToken = false;

  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');

  showDocumentation = false;
  showDocumentor = false;
  documentorData: any;
  docPartner: any;
  docAccount: any;
  docExecutor: any;


  showPage = true;
  settingsData: any;

  constructor(private _service: ConnecttocrudService, private route: ActivatedRoute, public platform: LeftpanelComponent, private router: Router, private dialog: MatDialog, private confPost: ConfService) { }

  ngOnInit() {
    this.getPages();
  }

  getPages() {
    this.display = [];
    this._service.getItemswithParameter('v1', 'services', 'services', 'documentation', null).subscribe(async response2 => {
      this.full = response2;
      if (this.full.length === 0) {
        await this.platform.postOverviewPageByDefaultIfNotExists(this.partner, this.account);
        this.getPages();
      }
      for (let i = 0; i < this.full.length; i++) {
        let flag = false;
        for (let j = 0; j < this.display.length; j++) {
          if (this.full[i].category_name !== undefined) {
            if (this.full[i].category_name === this.display[j].category_name) {
              flag = true;
              // this.display[j].category_group.push(this.full[i]);
              let titleFlag = false;
              for (let k = 0; k < this.display[j].category_group.length; k++) {
                if (this.full[i].title === this.display[j].category_group[k].title ) {
                  titleFlag = true;
                  this.display[j].category_group[k].versions.push(this.full[i]);
                }
              }
              if (!titleFlag) {
                this.display[j].category_group.push({title: this.full[i].title, versions: [this.full[i]]});
              }
            }
          } else {
            if ('Default' === this.display[j].category_name) {
              flag = true;
              // this.display[j].category_group.push(this.full[i]);
              let titleFlag = false;
              for (let k = 0; k < this.display[j].category_group.length; k++) {
                if (this.full[i].title === this.display[j].category_group[k].title ) {
                  titleFlag = true;
                  this.display[j].category_group[k].versions.push(this.full[i]);
                }
              }
              if (!titleFlag) {
                this.display[j].category_group.push({title: this.full[i].title, versions: [this.full[i]]});
              }
            }
          }
        }
        if (flag === false) {
          if (this.full[i].category_name === undefined) {
            this.display.push({'category_name': 'Default', 'category_group': [{title : this.full[i].title, versions: [this.full[i]]}]});
          } else {
            this.display.push({
              'category_name': this.full[i].category_name,
              'category_group': [{title : this.full[i].title, versions: [this.full[i]]}]
            });
          }
        }
      }
      this.route.queryParams.subscribe(params => {
        this._terms = undefined;
        this.showDocumentation = false;
        this.showPage = false;
        this.showDocumentor = false;
        if (params.showDoc !== undefined) {
          this.showDocumentation = true;
          this.showPage = false;
          if (!this.docPartner && !this.docAccount && !this.docExecutor) {
            this.showPage = true;
            this.showDocumentation = false;
            this.title = this.full[0].title;
            this.version = this.full[0].version;
            this._service.getItemswithParameter('v1', 'services', 'services', 'documentation', 'title=' + this.title + '&version=' + this.version).subscribe(response => {
              this._terms = response[0];
            });
          }
        } else if (params.title !== undefined && params.version !== undefined) {
          this.showPage = true;
          this.showDocumentation = false;
          this.title = params.title;
          this.version = params.version;
          this._service.getItemswithParameter('v1', 'services', 'services', 'documentation', 'title=' + this.title + '&version=' + this.version).subscribe(response => {
            this._terms = response[0];
          });
        } else {
          this.showPage = true;
          this.showDocumentation = false;
          if (this.full.length > 0) {
            this.title = this.full[0].title;
            this.version = this.full[0].version;
            this._service.getItemswithParameter('v1', 'services', 'services', 'documentation', 'title=' + this.title + '&version=' + this.version).subscribe(response => {
              this._terms = response[0];
            });
          }
        }
      });
    });
  }

}
